export * from './date-range.message';
export * from './decimal.message';
export * from './email.message';
export * from './file.message';
export * from './max-length.message';
export * from './max.message';
export * from './min-length.message';
export * from './min.message';
export * from './name.message';
export * from './nric.message';
export * from './number.message';
export * from './required.message';
export * from './tin.message';
export * from './uen.message';
